import React, { useCallback, useEffect, useState } from 'react'
import { paymentServices } from 'src/services/payment/Payment.service'
import { numberFormatterWithDecimalAndThousand } from 'src/helper/numberFormatterWithDecimalAndThousand'
import { useNotify, useTranslate } from 'react-admin'
import { parseDateFormat } from 'src/helper/parseDateFormat';
import {Skeleton, Button, TextField} from '@mui/material'
import { LoadingButton } from '@mui/lab';
import { accountServices } from 'src/services/payment/account/account.service';

export const EditCreditModal = ({id,creditData, onClose,updateCredits}) => {
    const notify = useNotify()
    const translate = useTranslate()
    const [editedCredit, setEditedCredit] = useState(
        {...creditData,amount_pending:numberFormatterWithDecimalAndThousand(creditData.amount_pending)}
    )
    const [isLoading, setIsLoading] = useState(false)

    const onChangeData = (amount) =>{
        setEditedCredit({...editedCredit, amount_pending:amount})
    }

    const onConfirm = () =>{
        const amount_str = editedCredit.amount_pending +''
        editedCredit.amount_pending = Number(amount_str.replace('.','').replace(',','.'))
        setIsLoading(true)
        accountServices.updateCreditPendingAmount(id, editedCredit).then(()=>{
            notify('ra.notification.credit_updated_success', {type:'success'})
            updateCredits()
            onClose()
        }).catch(()=>{
            notify('ra.notification.credit_updated_error', {type:'error'})
        }).finally(()=>{
            setIsLoading(false)
        })
    }

  return (
    <div>
        <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
            <div style={{display:'flex', flexDirection:'row',justifyContent:'space-evenly'}}>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                    <label>
                        {`Id`}
                    </label>
                    <label>
                        {editedCredit.id}
                    </label>
                    <label></label>
                </div>
                <div style={{display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                    <label>
                        {`${translate('ra.field.updated_at')}`}
                    </label>
                    <label >
                        {parseDateFormat(editedCredit.updated_at)}
                    </label>
                    <label></label>
                </div>
                <div style={{display:'flex', flexDirection:'column'}}>
                    <label>
                        {`${translate('ra.field.amount')}`}
                    </label>
                    <TextField
                        value={editedCredit.amount_pending}
                        size='small'
                        onBlur={(val)=>{onChangeData(numberFormatterWithDecimalAndThousand((val.target.value + '').replace('.', '').replace(',', '.')))}}
                        onChange={(val)=>{onChangeData(val.target.value)}}
                    />
                </div>
            </div>
        </div>

        <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', marginTop:'15px'}}>
            <Button variant='outlined' color='error' onClick={()=>{onClose()}}>
                {translate('ra.action.cancel')}
            </Button>
            <LoadingButton loading={isLoading} variant='contained' onClick={onConfirm}>
                {translate('ra.action.to_confirm')}
            </LoadingButton>
        </div>
        
    </div>
  )
}